import { Controller } from "@hotwired/stimulus"
import { showError, showSuccess } from '../src/lib/toastify-js'

// Connects to data-controller="flash"
export default class extends Controller {
  static values = {
    type: String,
    message: String
  }
  declare readonly typeValue: string
  declare readonly messageValue: string

  connect() {
    if(this.typeValue === 'notice') {
      showSuccess(this.messageValue)
    } else {
      showError(this.messageValue)
    }
  }
}
